// @ts-ignore
import { Fraction } from 'fractional';
import * as Types from '../Types';
export const INFINITE_SYMBOL = String.fromCharCode(8734);
export var RoundMode;
(function (RoundMode) {
    RoundMode["Default"] = "Default";
    RoundMode["Floor"] = "Floor";
    RoundMode["Ceil"] = "Ceil";
})(RoundMode || (RoundMode = {}));
/**
 * Formats the given number to the given currency
 * @param {number} value Number to format
 * @param {string} currency Currency iso (EUR)
 * @param {string} language Language (en, de)
 */
export const formatCurrency = (value, currency, language, roundMode = RoundMode.Default) => {
    let valueToFormat = value;
    switch (roundMode) {
        case RoundMode.Ceil:
            valueToFormat = Math.ceil(valueToFormat);
            break;
        case RoundMode.Floor:
            valueToFormat = Math.floor(valueToFormat);
            break;
        default:
            break;
    }
    return new Intl.NumberFormat(language, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: valueToFormat % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
    }).format(valueToFormat);
};
export const roundOdds = (value) => {
    return Math.round(value * 100 + Number.EPSILON) / 100;
};
/**
 * Formats the odds to rounded string
 * @param {number} value
 * @param {string} language Language (en, de)
 */
export const formatOdds = (odds, settings) => {
    odds = roundOdds(odds);
    switch (settings.oddsFormat) {
        case Types.OddsFormat.Fractional:
            if (odds === 0)
                return INFINITE_SYMBOL;
            const fractionalOdd = new Fraction(odds - 1);
            return `${fractionalOdd.numerator}/${fractionalOdd.denominator}`;
        case Types.OddsFormat.American:
            let americanOdd;
            if (odds === 0)
                return `+${INFINITE_SYMBOL}`;
            if (odds === 1)
                return `-${INFINITE_SYMBOL}`;
            else if (odds > 2) {
                americanOdd = (odds - 1) * 100;
            }
            else {
                americanOdd = -100 / (odds - 1);
            }
            return `${americanOdd < 0 ? '' : '+'}${Intl.NumberFormat(settings.language, {
                maximumFractionDigits: 0
            }).format(americanOdd)}`;
        case Types.OddsFormat.Winnings:
            return formatCurrency(odds * settings.stake, settings.currency, settings.language, RoundMode.Floor);
        default:
            return new Intl.NumberFormat(settings.language, {
                style: 'decimal',
                minimumFractionDigits: odds >= 10 ? 0 : 2,
                maximumFractionDigits: 2
            }).format(odds);
    }
};
//# sourceMappingURL=NumberFormatter.js.map